import { DataTrackLabelEnum } from 'app/shared/enums/data-track-label.enum';
import { NewAnalyticsEvent } from 'app/shared/models/new-analytics-event.model';
import { GameBaseEventAdapter } from 'app/student/game-section/analytics/events/game-base.event-adapter';

export class WebGLNotSupportedEventAdapter implements GameBaseEventAdapter {
  public prepareEvent(): NewAnalyticsEvent {
    return {
      eventType: DataTrackLabelEnum.WebGLNotSupported,
      jsonData: {
        userAgent: {
          raw: navigator.userAgent,
          browser: this.getBrowserInfo(),
          platform: this.getPlatformInfo()
        }
      }
    };
  }

  private getBrowserInfo(): any {
    const ua = navigator.userAgent;
    if (ua.match(/chrome|chromium|crios/i)) {
      const match = ua.match(/(?:Chrome|Chromium|Crios)\/([0-9.]+)/);
      return { name: 'Chrome', version: match ? match[1] : 'Unknown' };
    } if (ua.match(/firefox|fxios/i)) {
      const match = ua.match(/(?:Firefox|FxiOS)\/([0-9.]+)/);
      return { name: 'Firefox', version: match ? match[1] : 'Unknown' };
    } if (ua.match(/safari/i) && !/chrome/i.test(ua)) {
      const match = ua.match(/Version\/([0-9.]+)/);
      return { name: 'Safari', version: match ? match[1] : 'Unknown' };
    } if (ua.match(/opr\//i)) {
      const match = ua.match(/OPR\/([0-9.]+)/);
      return { name: 'Opera', version: match ? match[1] : 'Unknown' };
    } if (ua.match(/edg/i)) {
      const match = ua.match(/Edg\/([0-9.]+)/);
      return { name: 'Edge', version: match ? match[1] : 'Unknown' };
    }
    return { name: 'Unknown', version: 'Unknown' };
  }

  private getPlatformInfo(): any {
    const ua = navigator.userAgent;
    let os = 'Unknown';
    let isMobile = false;
    if (/Windows/i.test(ua)) {
      os = 'Windows';
    } else if (/Macintosh|Mac OS X/i.test(ua)) {
      os = 'macOS';
    } else if (/Linux/i.test(ua)) {
      os = 'Linux';
    } else if (/Android/i.test(ua)) {
      os = 'Android';
      isMobile = true;
    } else if (/iPhone|iPad|iPod/i.test(ua)) {
      os = 'iOS';
      isMobile = true;
    }
    return { os, isMobile };
  }
}
